import { useRedirect } from '@common/hooks/useRedirect';
import { AppealStatus } from '@seek/je-shared-data/lib/types/authentication';
import { getUser } from '@store/auth';
import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';

export const useRedirectUserWithoutRequestedAppealStatus = () => {
  const { countryCode } = useAppSelector(getLocalisation);
  const { currentUser } = useAppSelector(getUser);
  const { redirect } = useRedirect();

  if (currentUser?.appealStatus !== AppealStatus.REQUESTED) {
    redirect(`/${countryCode}/home`)();
  }
};
